import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

/**
 * @entity BaseKPFEditDefaultExtension
 */
@Entity()
export class BaseKPFEditDefaultExtension extends BaseEditExtension {
  public static override _class = 'BaseKPFEditDefaultExtension';
}
